import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import _isNil from "lodash/isNil";
import _get from "lodash/get";
import _pickBy from "lodash/pickBy";
import _isEmpty from "lodash/isEmpty";
import _omit from "lodash/omit";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This module uses variables named `context` which incorrectly trips up the
// eslint rule for react/destructuring-assignment, so it is disabled:
import uuidV4 from 'uuid/v4';
import appConfig from '@nerdwallet/app-config';
import { getCookies } from './cookies';
export var CORE_HTTP_HEADERS = {
  COOKIE: 'Cookie',
  REFERRER: 'Referrer',
  USER_AGENT: 'User-Agent',
  X_BROWSER_SESSION_ID: 'X-Browser-Session-ID',
  X_CALLER_CLIENT_ID: 'X-Caller-Client-ID',
  // this should really be X_CLIENT_ID, but we keep it for legacy reasons
  X_CLIENT_VERSION: 'X-Client-Version',
  X_COOKIE_ID: 'X-Cookie-ID',
  X_HEADER_CSRF_TOKEN: 'X-Header-CSRF-Token',
  X_KOUNT_SESSION_ID: 'X-Kount-Session-ID',
  X_MEMBER_IDENTITY_ASSERTION_TOKEN: 'X-Member-Identity-Assertion-Token',
  X_ORIGINATING_APPLICATION_ID: 'X-Originating-Application-ID',
  X_ORIGINATING_IP: 'X-Originating-IP',
  X_ORIGINATING_REFERRER: 'X-Originating-Referrer',
  X_ORIGINATING_URL: 'X-Originating-URL',
  X_ORIGINATING_USER_AGENT: 'X-Originating-User-Agent',
  X_PAGEVIEW_ID: 'X-Pageview-ID',
  X_REFERRING_CALLER_CLIENT_ID: 'X-Referring-Caller-Client-ID',
  X_REQUEST_ID: 'X-Request-ID',
  X_TEST_STATE: 'X-Test-State',
  X_VISITOR_TOKEN: 'X-Visitor-Token',
  X_VISITOR_IDENTITY_ASSERTION_TOKEN: 'X-Visitor-Identity-Assertion-Token'
};
var CORE_HTTP_COOKIES = {
  ACCESS_TOKEN: 'access_token',
  JWT_ACCESS_TOKEN: 'jwt_access_token',
  CSRF_TOKEN: 'csrf_token',
  TEST_STATE: 'test_state',
  VISITOR_TOKEN: 'visitor_token'
};
/**
 * Prefix for WP cookies used for:
 *   1. authed WP API requests
 *   2. bypassing our edge cache
 *
 * @link https://github.com/NerdWallet/edge-configs/blob/2c5684bc4fea9e052d62202dbae2cce7566d5b35/src/templates/location.conf.jinja#L133)
 *
 * @type {string}
 */

var WP_COOKIE_PREFIX = 'wordpress_'; // --- Helpers ---

/**
 * Replaces unsafe control characters in a string
 *
 * @param {string} [str]
 * @param {string} [replace]
 *
 * @return {string}
 */

var replaceControlCharacters = function replaceControlCharacters(str, replace) {
  if (str) {
    // eslint-disable-next-line no-control-regex
    return str.replace(/[\x00-\x1F\x7F]/g, replace);
  }

  return '';
};
/**
 * Return the full URL of the request
 *
 * @param {object} [serverRequest]
 *
 * @return {string}
 */


var getRequestUrl = function getRequestUrl(serverRequest) {
  return "".concat(serverRequest.protocol, "://").concat(serverRequest.get('Host')).concat(serverRequest.originalUrl);
};
/**
 * Calls the appropriate function to sanitize a header
 *
 * @param {string} [header]
 *
 * @return {string}
 */


var sanitizeHeader = function sanitizeHeader(header) {
  return replaceControlCharacters(header, ' ');
}; // Safe access to window global properties


function getWindowProp(property) {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
    return window[property];
  }

  return null;
}
/**
 * Safe access to window.document.referrer
 *
 * @return {string}
 */


function getDocumentReferrer() {
  if (getWindowProp('document')) {
    // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
    return window.document.referrer;
  }

  return null;
}
/**
 * Calls the appropriate functions to sanitize a user defined cookie
 * @param {string} [key]
 * @param {string} [value]
 *
 * @return {string}
 */


function sanitizeCookie(key, value) {
  // Key sanitization is just precautionary, there should never be a case where a user
  // is given the ability to send cookies with arbitrary keys to services
  var cookieKey = replaceControlCharacters(key, ' ').replace(/;/g, '%3B');
  var cookieValue = replaceControlCharacters(value, ' ').replace(/;/g, '%3B');
  return "".concat(cookieKey, "=").concat(cookieValue);
} // Given a cookie object returns a string for the Cookie header


function buildCookieString(cookies) {
  var sanitizedPairs = []; // eslint-disable-next-line no-restricted-syntax

  for (var k in cookies) {
    sanitizedPairs.push("".concat(sanitizeCookie(k, cookies[k]), ";"));
  }

  var cookieString = sanitizedPairs.join('');
  return cookieString;
} // --- Header functions ---

/**
 * Return the `Cookie` header.
 *
 * @param {object} [context]
 * @param {object} [context.coreCookies]
 * @param {object} [context.inputCookies]
 *
 *
 * @return {string}
 */


var getCookieHeader = function getCookieHeader(_ref) {
  var coreCookies = _ref.coreCookies,
      inputCookies = _ref.inputCookies;

  var allCookies = _omit(_objectSpread({}, inputCookies, coreCookies), // The `test_state` cookie does not need to be propogated because it will be sent in the request header `X-Test-State`
  [CORE_HTTP_COOKIES.TEST_STATE]); // Set the cookie header, except for in browsers and mobile (when process.browser
  // is present). Browsers and mobile don't allow setting the cookie header, they
  // automatically manage cookies.


  if (!process.browser && !_isEmpty(allCookies)) {
    return buildCookieString(allCookies);
  }

  return null;
};
/**
 * Return the `X-Browser-Session-ID` header.
 *
 * @param {object} [context]
 * @param {string} [context.url]
 * @param {object} [context.serverRequest]
 * @param {object} [context.config]
 *
 * @return {string}
 */


var getBrowserSessionID = function getBrowserSessionID(context) {
  // Get the unsigned browser session id for the request header in the case that the client
  // doesn't have a valid browser_session_id in their cookies. This is used for mobile where
  // theres no initial request to www. for nginx to return a Set-Cookie header with a signed
  // browser session id.
  if (context.config && context.config.getBrowserSessionIdOverride) {
    return context.config.getBrowserSessionIdOverride(context);
  }

  if (context.serverRequest) {
    return context.serverRequest.get(CORE_HTTP_HEADERS.X_BROWSER_SESSION_ID);
  }

  return null;
};
/**
 * Return the `X-Cookie-ID` header.
 *
 * @param {object} [context]
 * @param {string} [context.url]
 * @param {object} [context.config]
 * @param {object} [context.serverRequest]
 *
 * @return {string}
 */


var getCookieID = function getCookieID(context) {
  // Get the unsigned cookie id for the request header in the case that the client doesn't have
  // a valid cookie_id in their cookies. This is used for mobile where theres no initial
  // request to www. for nginx to return a Set-Cookie header with a signed cookie id.
  if (context.config && context.config.getCookieIdOverride) {
    return context.config.getCookieIdOverride(context);
  }

  if (context.serverRequest) {
    return context.serverRequest.get(CORE_HTTP_HEADERS.X_COOKIE_ID);
  } // In a browser, we rely on the `cookie_id` cookie to be sent along with the request.
  // The edge is responsible for setting the `X-Cookie-ID` header on inbound requests.


  return null;
};
/**
 * Return the `X-Header-CSRF-Token` header. In a server context, we should simply pass along the csrf header from
 * the incoming request. In other contexts (browser, React Native app) we use existing csrf cookie.
 *
 * @param {object} [context]
 * @param {object} [context.serverRequest]
 * @param {object} [context.coreCookies]
 *
 * @return {string}
 */


var getCsrfToken = function getCsrfToken(_ref2) {
  var serverRequest = _ref2.serverRequest,
      coreCookies = _ref2.coreCookies;

  if (serverRequest) {
    return serverRequest.get(CORE_HTTP_HEADERS.X_HEADER_CSRF_TOKEN);
  }

  return coreCookies[CORE_HTTP_COOKIES.CSRF_TOKEN];
};
/**
 * Return the `X-Originating-IP` header.
 *
 * @param {object} [context]
 * @param {object} [context.serverRequest]
 *
 * @return {string}
 */


var getOriginatingIP = function getOriginatingIP(_ref3) {
  var serverRequest = _ref3.serverRequest;

  if (serverRequest) {
    return serverRequest.ip;
  }

  return null;
};
/**
 * Return the `X-Originating-Referrer` header.
 *
 * @param {object} [context]
 * @param {object} [context.config]
 * @param {object} [context.serverRequest]
 *
 * @return {string}
 */


var getOriginatingReferrer = function getOriginatingReferrer(_ref4) {
  var config = _ref4.config,
      serverRequest = _ref4.serverRequest;

  if (serverRequest) {
    // Forward `X-Originating-Referrer` if it exists, otherwise look at the request's referrer.
    return serverRequest.get(CORE_HTTP_HEADERS.X_ORIGINATING_REFERRER) || serverRequest.get(CORE_HTTP_HEADERS.REFERRER);
  }

  if (config && config.nwa) {
    return config.nwa.getGlobalProp('referrer') || getDocumentReferrer();
  }

  return null;
};
/**
 * Return the `X-Request-ID` header.
 *
 * @param {object} [context]
 * @param {object} [context.serverRequest]
 *
 * @return {string}
 */


var getRequestID = function getRequestID(_ref5) {
  var serverRequest = _ref5.serverRequest;

  if (serverRequest) {
    var requestId = serverRequest.get(CORE_HTTP_HEADERS.X_REQUEST_ID);

    if (requestId) {
      return requestId;
    }
  }

  return uuidV4();
};
/**
 * Return the `X-Originating-URL` header.
 *
 * @param {object} [context]
 * @param {object} [context.config]
 * @param {object} [context.serverRequest]
 *
 * @return {string}
 */


var getOriginatingURL = function getOriginatingURL(_ref6) {
  var config = _ref6.config,
      serverRequest = _ref6.serverRequest;

  if (config.getUrl) {
    return config.getUrl();
  }

  if (serverRequest) {
    // Forward `X-Originating-URL` if it exists, otherwise look at the request url.
    return serverRequest.get(CORE_HTTP_HEADERS.X_ORIGINATING_URL) || getRequestUrl(serverRequest);
  }

  if (config && config.nwa) {
    return config.nwa.getGlobalProp('url');
  }

  if (getWindowProp('location')) {
    // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
    return window.location.href;
  }

  return null;
};
/**
 * Return the `X-Originating-User-Agent` header.
 *
 * @param {object} [context]
 * @param {object} [context.serverRequest]
 *
 * @return {string}
 */


var getOriginatingUserAgent = function getOriginatingUserAgent(_ref7) {
  var serverRequest = _ref7.serverRequest;

  // Forward `X-Originating-User-Agent` if it exists, otherwise look at the request's referrer.
  if (serverRequest) {
    return serverRequest.get(CORE_HTTP_HEADERS.X_ORIGINATING_USER_AGENT) || serverRequest.get(CORE_HTTP_HEADERS.USER_AGENT);
  }

  if (getWindowProp('navigator')) {
    // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
    return window.navigator.userAgent;
  }

  return null;
};
/**
 * Return the `X-Pageview-ID` header.
 * @param {object} [context]
 * @param {object} [context.config]
 *
 * @return {string}
 */


var getPageviewID = function getPageviewID(_ref8) {
  var config = _ref8.config;

  if (config.getPageviewId) {
    return config.getPageviewId();
  }

  if (config && config.nwa) {
    return config.nwa.getGlobalProp('pageViewId');
  }

  return null;
};
/**
 * Return the `X-Test-State` header.
 *
 * Propagate the test state header if this is a server request.
 * Part of the "QA Test States" protocol - see https://nerdwallet.atlassian.net/wiki/spaces/ENG/pages/515539477/2018-12-20+QA+Test+States
 * TODO(UDC-4431) - Replace project spec with cleaner docs once complete.
 *
 * @param {object} [context]
 * @param {object} [context.serverRequest]
 * @param {object} [context.coreCookies]
 *
 * @return {string}
 */


var getTestState = function getTestState(_ref9) {
  var serverRequest = _ref9.serverRequest,
      coreCookies = _ref9.coreCookies;

  if (serverRequest && serverRequest.get(CORE_HTTP_HEADERS.X_TEST_STATE)) {
    return serverRequest.get(CORE_HTTP_HEADERS.X_TEST_STATE);
  }

  return coreCookies[CORE_HTTP_COOKIES.TEST_STATE];
};
/**
 * Return the `X-Vistor-Token` header.
 *
 * @param {object} [context]
 * @param {object} [context.serverRequest]
 *
 * @return {string}
 */


var getVisitorToken = function getVisitorToken(_ref10) {
  var serverRequest = _ref10.serverRequest;

  if (serverRequest) {
    return serverRequest.get('X-Visitor-Token');
  }

  return null;
};
/**
 * Return the `X-Member-Identity-Assertion-Token` header.
 *
 * @param {object} [context]
 * @param {object} [context.serverRequest]
 *
 * @return {string|null}
 */


var getMemberIdentityAssertionToken = function getMemberIdentityAssertionToken(_ref11) {
  var serverRequest = _ref11.serverRequest;

  if (serverRequest) {
    return serverRequest.get(CORE_HTTP_HEADERS.X_MEMBER_IDENTITY_ASSERTION_TOKEN);
  } // On clients, the member_identity_assertion_token cookie will
  // automatically be sent, so no header is needed.


  return null;
};
/**
 * Return the `X-Visitor-Identity-Assertion-Token` header.
 *
 * @param {object} [context]
 * @param {object} [context.serverRequest]
 *
 * @return {string|null}
 */


var getVisitorIdentityAssertionToken = function getVisitorIdentityAssertionToken(_ref12) {
  var serverRequest = _ref12.serverRequest;

  if (serverRequest) {
    return serverRequest.get(CORE_HTTP_HEADERS.X_VISITOR_IDENTITY_ASSERTION_TOKEN);
  } // On clients, the visitor_identity_assertion_token cookie will
  // automatically be sent, so no header is needed.


  return null;
};
/**
 * Return WP cookies via the `getCookies` helper.
 *
 * @param {object} [existingCookies]
 *
 * @return {object}
 */


var pickWpCookies = function pickWpCookies(existingCookies) {
  return _pickBy(existingCookies, function (value, key) {
    return key.indexOf(WP_COOKIE_PREFIX) === 0;
  });
};
/**
 * Return the core cookies via the `getCookies` helper.
 *
 * @param {object} [context]
 * @param {string} [context.url]
 * @param {object} [context.config]
 * @param {object} [context.serverRequest]
 *
 * @return {object}
 */


var getCoreCookies = function getCoreCookies(context) {
  return getCookies(context).then(function (existingCookies) {
    var _pickBy2;

    var coreCookies = _pickBy((_pickBy2 = {}, _defineProperty(_pickBy2, CORE_HTTP_COOKIES.ACCESS_TOKEN, existingCookies[CORE_HTTP_COOKIES.ACCESS_TOKEN]), _defineProperty(_pickBy2, CORE_HTTP_COOKIES.JWT_ACCESS_TOKEN, existingCookies[CORE_HTTP_COOKIES.JWT_ACCESS_TOKEN]), _defineProperty(_pickBy2, CORE_HTTP_COOKIES.CSRF_TOKEN, existingCookies[CORE_HTTP_COOKIES.CSRF_TOKEN]), _defineProperty(_pickBy2, CORE_HTTP_COOKIES.TEST_STATE, existingCookies[CORE_HTTP_COOKIES.TEST_STATE]), _defineProperty(_pickBy2, CORE_HTTP_COOKIES.VISITOR_TOKEN, existingCookies[CORE_HTTP_COOKIES.VISITOR_TOKEN]), _pickBy2));

    var wpCookies = pickWpCookies(existingCookies);
    return _objectSpread({}, coreCookies, wpCookies);
  });
};
/**
 * Returns an object with all of the core http headers set.
 *
 * @param {object} [context]
 * @param {string} [context.url]
 * @param {object} [context.config]
 * @param {object} [context.serverRequest]
 * @param {object} [context.cookies]
 * @param {object} [context.referringClientID]
 *
 * @return {object}
 */


export var getCoreHTTPHeaders = function getCoreHTTPHeaders(_ref13) {
  var url = _ref13.url,
      config = _ref13.config,
      serverRequest = _ref13.serverRequest,
      inputCookies = _ref13.cookies,
      referringClientID = _ref13.referringClientID,
      _ref13$kountSessionID = _ref13.kountSessionID,
      kountSessionID = _ref13$kountSessionID === void 0 ? getWindowProp('__KOUNT_SESSION_ID__') : _ref13$kountSessionID;
  return getCoreCookies({
    url: url,
    config: config,
    serverRequest: serverRequest
  }).then(function (coreCookies) {
    var _headers;

    var headers = (_headers = {}, _defineProperty(_headers, CORE_HTTP_HEADERS.COOKIE, getCookieHeader({
      coreCookies: coreCookies,
      inputCookies: inputCookies
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_BROWSER_SESSION_ID, getBrowserSessionID({
      url: url,
      config: config,
      serverRequest: serverRequest
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_CALLER_CLIENT_ID, config.clientID), _defineProperty(_headers, CORE_HTTP_HEADERS.X_CLIENT_VERSION, _get(appConfig, '_meta.version')), _defineProperty(_headers, CORE_HTTP_HEADERS.X_COOKIE_ID, getCookieID({
      config: config,
      serverRequest: serverRequest
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_HEADER_CSRF_TOKEN, getCsrfToken({
      serverRequest: serverRequest,
      coreCookies: coreCookies
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_KOUNT_SESSION_ID, kountSessionID), _defineProperty(_headers, CORE_HTTP_HEADERS.X_MEMBER_IDENTITY_ASSERTION_TOKEN, getMemberIdentityAssertionToken({
      serverRequest: serverRequest
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_ORIGINATING_APPLICATION_ID, config.applicationID), _defineProperty(_headers, CORE_HTTP_HEADERS.X_ORIGINATING_IP, getOriginatingIP({
      serverRequest: serverRequest
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_ORIGINATING_REFERRER, getOriginatingReferrer({
      config: config,
      serverRequest: serverRequest
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_ORIGINATING_URL, getOriginatingURL({
      serverRequest: serverRequest,
      config: config
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_ORIGINATING_USER_AGENT, getOriginatingUserAgent({
      serverRequest: serverRequest
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_PAGEVIEW_ID, getPageviewID({
      config: config
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_REFERRING_CALLER_CLIENT_ID, referringClientID), _defineProperty(_headers, CORE_HTTP_HEADERS.X_REQUEST_ID, getRequestID({
      serverRequest: serverRequest
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_TEST_STATE, getTestState({
      serverRequest: serverRequest,
      coreCookies: coreCookies
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_VISITOR_TOKEN, getVisitorToken({
      serverRequest: serverRequest
    })), _defineProperty(_headers, CORE_HTTP_HEADERS.X_VISITOR_IDENTITY_ASSERTION_TOKEN, getVisitorIdentityAssertionToken({
      serverRequest: serverRequest
    })), _headers); // Sanitize all headers

    return Object.keys(headers).reduce(function (accumulator, headerName) {
      // Remove any values that are `null` or `undefined`.
      // Node and browsers normally ignore null header values, but React Native's Android HTTP
      // implementation will crash if a null header value is present.
      if (!_isNil(headers[headerName])) {
        accumulator[headerName] = sanitizeHeader(headers[headerName]);
      }

      return accumulator;
    }, {});
  });
};